module.exports = __webpack_public_path__ + "img/spot2.82dbb15b.svg";